<script>
  /* Executable code section of the program */
  // Components importation
  import Loader from "../../components/Loader.svelte";
  import EmptyTable from "../../components/EmptySections/EmptyTable.svelte";
  import AttendeesMeetModal from "../../components/Modals/attendeesMeetModal.svelte";
  import ConfirmModal from "../../components/Modals/ConfirmModal.svelte";
  //Tool importation
  import {
    userLocalData,
    isProtectedRoute,
    isAttendeeMeetModalOn,
    temporalMeetInfo,
    isConfirmModalOn,
    confirmResponse,
    alertMessagge,
    isAlertOn,
    isReloadNecessary,
  } from "../../apis/storage";
  import {
    getCollection,
    auth,
    filterMeetingsFuction,
    getPaginatedMeetings,
    getSpecificDocuments,
    deleteDocument,
    deleteCustomElements,
    filtrarDocumentos
  } from "../../apis/APIS";
  import { onMount } from "svelte";
  import { onAuthStateChanged } from "firebase/auth";
  import AlertModal from "../../components/Modals/alertModal.svelte";

  //Auxiliary variables
  $: dinamicData = [];
  let isContentLoaded = false;
  let eventsNames = [];
  $: breaksInfoArray = [];
  let breaksNames = [];
  let isBreakFilterOn = false;
  let isFilterFuction;
  let filterOn = true;
  let typedValue = "";

  // Definition of the window witdh
  let windowSize = window.innerWidth;

  //Auxiliary Variables
  let lastDocument = null;
  let reservDocument = [];
  let meetingsArray = [];
  let totalMeetingsArray = [];
  let totalFilterArray = [];
  let isArrayComplete = false;
  let index = 0;
  let totalDocuments = 10;
  let eventUser;
  let breakSelected;
  let currentEvent;
  let allAttendees = [];
  let currentData = {};

  //Funcion para unir los arrays de los attendees
  const attendeesArrayUnion = (meeting) => {

    allAttendees = [
      ...(meeting.acceptedAttendees || []),
      ...(meeting.declinedAttendees || []),
      ...(meeting.invitedAttendees || []),
    ];
    return allAttendees;
  };

  //Function to filter data
  const filterMeetings = async () => {
    isFilterFuction = true;
    filterOn = false;
    let breakSelect = document.querySelector(".breakSelect");
    breakSelected = breakSelect.value;

    const { completeCollection, lastDoc } = await filterMeetingsFuction(
      "meetings",
      eventUser,
      "breakTittle",
      breakSelected
    );
    if (
      completeCollection == undefined ||
      completeCollection == null ||
      completeCollection == []
    ) {
      dinamicData = [];
    } else {
      dinamicData = completeCollection;
    }
  };

  //Function to filter meetings by status
  const filterMeetingStatus = async () => {
    isFilterFuction = true;
    filterOn = false;
    let breakSelect = document.querySelector(".statusSelect");
    breakSelected = breakSelect.value;

    const { completeCollection, lastDoc } = await filterMeetingsFuction(
      "meetings",
      eventUser,
      "meetStatus",
      breakSelected
    );
    if (
      completeCollection == undefined ||
      completeCollection == null ||
      completeCollection == []
    ) {
      dinamicData = [];
    } else {
      dinamicData = completeCollection;
    }
  };

  //Function to filter meetings by attendees
  const filterAttendeesMeeting = async (value) => {
    filterOn = false
    let meetings = await getSpecificDocuments("meetings", "event", eventUser);
    let newMeetings = await filtrarDocumentos(meetings,value);
    dinamicData = newMeetings
  };

  //Function to get documents and create pagination
  const nextPageData = async () => {
    // Normal pagination
    if (!isArrayComplete) {
      const { documents, lastDoc } = await getPaginatedMeetings(
        "meetings",
        eventUser,
        totalDocuments,
        lastDocument
      );
      if (documents.length === 0) {
        isArrayComplete = true;
      }

      if (documents.length > 0) {
        if (
          !totalMeetingsArray.some(
            (obj) => JSON.stringify(obj) === JSON.stringify(documents[0])
          ) &&
          !isArrayComplete
        ) {
          totalMeetingsArray.push(documents);
          dinamicData = documents;
          lastDocument = lastDoc;
          reservDocument.push(lastDoc);
          index++;
        }
      }
    } else {
      if (index < totalMeetingsArray.length - 1) {
        index++;
      }
      dinamicData = totalMeetingsArray[index];
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prevPageData = async () => {
    if (index >= 1) {
      index--;
      if (!isArrayComplete) {
        lastDocument = reservDocument[index];
      }
      dinamicData = totalMeetingsArray[index];
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  //Reset function
  const resetDocuments = async () => {
    /* dinamicData = meetingsArray;
    isFilterFuction = false;
    index = 0;
    isArrayComplete = false;
    typedValue = "";
    lastDocument = reservDocument[0] */
    location.reload();
  };

  //Function to get attendees acording to event
  const eventMeetings = async () => {
    let eventSelect = document.querySelector(".eventSelect");
    let eventValue = eventSelect.value;
    eventUser = eventValue;

    //Names for breaks

    breaksNames = await getSpecificDocuments(
      "breaks",
      "eventBreak",
      eventValue
    );

    //fetch documents
    const { documents, lastDoc } = await getPaginatedMeetings(
      "meetings",
      eventValue,
      totalDocuments,
      lastDocument
    );
    if (documents == undefined || documents == null || documents == []) {
      dinamicData = [];
    } else {
      totalMeetingsArray.push(documents);
      meetingsArray = documents;
      dinamicData = meetingsArray;
      lastDocument = lastDoc;
      reservDocument.push(dinamicData);
    }

    ////Filter break array designation
    currentEvent = await getSpecificDocuments("events", "tittle", eventValue);

    isBreakFilterOn = true;
  };

  //Function to display meetInfo modal
  const displayMeetModal = (data) => {
    $isAttendeeMeetModalOn = true;
    $temporalMeetInfo = data;
  };
  //Function to go back
  const goBack = () => {
    window.history.back();
  };

    //Function to display alert
    const displayAlert = () => {
    $isAlertOn = true;
  };

  //Function to display confirm modal
  const displayConfirmModal = (data) => {
    currentData = data;
    $isConfirmModalOn = true;
    $alertMessagge = "Are you sure you want to delete this meeting?";
  };

  //Function to delete meetings
  const deleteMeeting = async (meeting) => {
    let deleteAttendeesMeeting = [];
    if ($confirmResponse) {
      if (currentData.meetType === "Regular") {
        deleteDocument("meetings", currentData.id)
          .then(() => {
            deleteAttendeesMeeting.push({
              id: currentData.host.id,
              fieldName: "scheduledMeetings",
              values: [currentData.id],
            });
            deleteAttendeesMeeting.push({
              id: currentData.invitedAttendees[0].id,
              fieldName: "scheduledMeetings",
              values: [currentData.id],
            });
            deleteCustomElements("users", deleteAttendeesMeeting).then(() => {
              $isReloadNecessary = true
              $alertMessagge = "Meeting deleted successfully."
              displayAlert();
            })
            .catch(()=>{
              $alertMessagge = "There was an error deleting the meeting."
              displayAlert();
            })
          })
          .catch(() => {
              $alertMessagge = "There was an error deleting the meeting."
              displayAlert();
            });
      } else {
        deleteDocument("meetings", currentData.id)
          .then(() => {
            deleteAttendeesMeeting.push({
              id: currentData.host.id,
              fieldName: "scheduledMeetings",
              values: [currentData.id],
            });
            deleteAttendeesMeeting.push({
              id: currentData.invitedAttendees[0].id,
              fieldName: "scheduledMeetings",
              values: [currentData.id],
            });
            deleteCustomElements("users", deleteAttendeesMeeting).then(() => {
              $isReloadNecessary = true
              $alertMessagge = "Meeting deleted successfully."
              displayAlert();
            })
            .catch(()=>{
              $alertMessagge = "There was an error deleting the meeting."
              displayAlert();
            })
          })
          .catch(() => {
              $alertMessagge = "There was an error deleting the meeting."
              displayAlert();
            });
      }
    }
  };

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments(
          "users",
          "email",
          user.email
        );
        if ($userLocalData[0].userRole === "attendee") {
          navigate("/home");
        }
        eventsNames = await getCollection("events");

        // Temporizador del loader
        setTimeout(() => (isContentLoaded = true), 1500);
      } else {
        navigate("/");
      }
    });
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isContentLoaded}
    <body>
      <div class="backBtnContainer">
        <button class="backBtn" on:click={goBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
            />
          </svg> Go Back</button
        >
      </div>
      <div class="headerContent">
        <h3>Meetings</h3>
      </div>
      <div class="filterSections">
        <div class="form-floating">
          <select
            class="form-select eventSelect"
            name="country"
            id="floatingSelect"
            aria-label="Floating label select example"
            on:change={eventMeetings}
          >
            <option selected>Select a event</option>
            {#each eventsNames as event}
              <option value={event.tittle}>{event.tittle}</option>
            {/each}
          </select>
          <label for="floatingSelect">Events</label>
        </div>
        {#if isBreakFilterOn}
          <div class="form-floating">
            <select
              class="form-select breakSelect"
              name="country"
              id="floatingSelect"
              aria-label="Floating label select example"
              on:change={filterMeetings}
            >
              <option selected>Select a break</option>
              {#each breaksNames as currentBreak}
                <option value={currentBreak.breakTittle}
                  >{currentBreak.breakTittle}</option
                >
              {/each}
            </select>
            <label for="floatingSelect">Meeting Status</label>
          </div>
          <div class="form-floating">
            <select
              class="form-select statusSelect"
              name="country"
              id="floatingSelect"
              aria-label="Floating label select example"
              on:change={filterMeetingStatus}
            >
              <option selected>Select a break</option>
              <option value="accepted">Accepted Meetings</option>
              <option value="declined">Declined Meetings</option>
              <option value="pending">Pending Meetings</option>
            </select>
            <label for="floatingSelect">Networking Break</label>
          </div>
          <button
            class="actionButton filterBtn"
            on:click={() => resetDocuments()}>Reset</button
          >
        {/if}
      </div>
      {#if isBreakFilterOn}
      <div class="moreFilters">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="floatingInput"
            placeholder="Search"
            bind:value={typedValue}
          />
          <label for="floatingInput">Search</label>
        </div>
        <button
          class="actionButton filterBtn"
          on:click={() => filterAttendeesMeeting(typedValue)}
          on:keypress={() => filterAttendeesMeeting(typedValue)}
          >Search</button
        >
      </div>
      {/if} 

      <div class="listContainer">
        {#if dinamicData.length > 0}
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Break Attendees</th>
                {#if windowSize > 1100}
                  <th scope="col">Table Number</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End Time</th>
                  <th scope="col">Meeting Type</th>
                  <th scope="col">Place</th>
                  <th scope="col">Meeting Status</th>
                {:else if windowSize > 700 && windowSize <= 1100}
                  <th scope="col">Table Number</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">Meeting Type</th>
                  <th scope="col">Place</th>
                  <th scope="col">Meeting Status</th>
                {/if}
                {#if windowSize < 1100}
                  <th scope="col">Description</th>
                {/if}
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {#each dinamicData as meetings, index}
                <tr>
                  <th scope="row">{index + 1}</th>
                  <td class="attendeesList">
                    <ul>
                      <li>{meetings.host.name} {meetings.host.surname}</li>
                      {#each attendeesArrayUnion(meetings) as attendees}
                        <li>
                          {attendees.name || attendees.attendeeName}
                          {attendees.surname || attendees.attendeeSurname}
                        </li>
                      {/each}
                    </ul>
                  </td>
                  {#if windowSize > 1100}
                    <td style="text-align: center;"
                      >{meetings.meetingCustomTable ||
                        meetings.meetingTable}</td
                    >
                    <td>{meetings.meetingTime.startTime}</td>
                    <td>{meetings.meetingTime.endTime}</td>
                    <td>{meetings.meetType}</td>
                    <td>{meetings.placeBreak || "N/A"}</td>
                    <td>{meetings.meetStatus || "N/A"}</td>
                  {:else if windowSize > 700 && windowSize <= 1100}
                    <td style="text-align: center;">{meetings.meetingTable}</td>
                    <td>{meetings.meetingTime.startTime}</td>
                    <td>{meetings.meetType}</td>
                    <td>{meetings.placeBreak || "N/A"}</td>
                    <td>{meetings.meetStatus || "N/A"}</td>
                  {/if}
                  {#if windowSize < 1100}
                    <td style="text-align: center;">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="bi bi-eye-fill icon"
                        viewBox="0 0 16 16"
                        on:click={() => displayMeetModal(meetings)}
                        on:keypress={() => displayMeetModal(meetings)}
                      >
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                        <path
                          d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                        />
                      </svg>
                    </td>
                  {/if}
                  <td style="text-align: center;"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-trash icon"
                      viewBox="0 0 16 16"
                      on:click={displayConfirmModal(meetings)}
                      on:keypress={displayConfirmModal(meetings)}
                    >
                      <path
                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
                      />
                      <path
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
                      />
                    </svg></td
                  >
                </tr>
              {/each}
            </tbody>
          </table>
        {:else}
          <EmptyTable />
        {/if}
      </div>
      {#if filterOn}
        <div class="paginationBtns">
          <button class="actionButton filterBtn" on:click={prevPageData}
            >Previous page</button
          >
          <button class="actionButton filterBtn" on:click={nextPageData}
            >Next page</button
          >
        </div>
      {/if}
    </body>
  {:else}
    <Loader />
  {/if}
{/if}
{#if $isAttendeeMeetModalOn}
  <AttendeesMeetModal />
{/if}
{#if $isAlertOn}
  <AlertModal/>
{/if}
{#if $isConfirmModalOn}
  <ConfirmModal callbackFunction={deleteMeeting} />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  body {
    background-color: #f4f4f4;
    width: 100%;
    min-height: 89vh;
    height: auto;
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Back Button styles */
  .backBtnContainer {
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }
  .backBtn {
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover {
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  .headerContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    padding: 20px;
  }
  /* Filter styles */
  .filterSections,.moreFilters {
    width: 90%;
    height: auto;
    padding: 20px 0;
    display: flex;
    align-items: flex-end;
  }
  .form-floating {
    width: 250px;
    height: 50px;
    margin: 10px;
  }
  /* Table styles */
  .listContainer {
    background-color: white;
    width: 90%;
    height: auto;
    padding: 30px;
  }
  .filterBtn {
    height: 40px;
    width: 100px;
  }
  .attendeesList {
    height: auto;
    max-height: 30px;
    overflow: auto;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .paginationBtns {
    width: 90%;
    height: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  .icon:hover {
    cursor: pointer;
    color: #ed2824;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .headerContent {
      width: 90%;
      padding: 20px;
    }
    /* Filter styles */
    .filterSections,.moreFilters {
      width: 90%;
      height: auto;
      padding: 20px 0;
      display: flex;
      align-items: flex-end;
    }
    .listContainer {
      background-color: white;
      width: 90%;
      height: auto;
      padding: 30px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .headerContent {
      width: 100%;
      padding: 10px;
      flex-direction: column;
      font-size: 25px;
      align-items: flex-start;
    }
    /* Filter styles */
    .filterSections,.moreFilters {
      width: 90%;
      height: auto;
      padding: 20px 0;
      flex-direction: column;
      align-items: flex-start;
    }
    .filterBtn {
      font-size: 20px;
      padding: 10px;
      height: auto;
      width: 100%;
      margin: 10px 0;
    }
    /* Filter styles */
    .filterSections,.moreFilters {
      width: 100%;
      padding: 10px 0;
    }
    .form-floating {
      width: 300px;
      height: 50px;
      margin: 10px 0;
    }
    .listContainer {
      background-color: white;
      width: 100%;
      height: auto;
      padding: 10px;
    }
    .paginationBtns {
      flex-direction: column;
    }
  }

  /* End of the section */
</style>
